import { intervalToDuration, isValid } from 'date-fns';
import { I18N_KEY } from '../constants/I18n';

export const WAITING_TIME_UNITS = Object.freeze({
  lessThanMinute: I18N_KEY.waitingTimeLessThanMinute,
  minutes: I18N_KEY.minutes,
  hours: I18N_KEY.hours,
  days: I18N_KEY.days,
  months: I18N_KEY.months,
  years: I18N_KEY.years,
});

const ORDERED_UNITS = [
  WAITING_TIME_UNITS.years,
  WAITING_TIME_UNITS.months,
  WAITING_TIME_UNITS.days,
  WAITING_TIME_UNITS.hours,
  WAITING_TIME_UNITS.minutes,
];

const INVALID_WAITING_TIME = Object.freeze({
  unit: null,
  value: null,
  text: '',
});

const normalizeDate = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  return isValid(date) ? date : null;
};

export const waitingTimeFromDates = (firstDate, secondDate, localizer) => {
  const normalizedFirstDate = normalizeDate(firstDate);
  const normalizedSecondDate = normalizeDate(secondDate);
  if (!normalizedFirstDate || !normalizedSecondDate) return { ...INVALID_WAITING_TIME };

  const [start, end] = normalizedFirstDate <= normalizedSecondDate
    ? [normalizedFirstDate, normalizedSecondDate]
    : [normalizedSecondDate, normalizedFirstDate];
  const duration = intervalToDuration({ start, end });
  const unit = ORDERED_UNITS.find((item) => duration[item] > 0);

  if (!unit) {
    return {
      unit: WAITING_TIME_UNITS.lessThanMinute,
      value: 0,
      text: localizer.t(I18N_KEY.waitingTimeLessThanMinute),
    };
  }

  const value = duration[unit];
  return {
    unit,
    value,
    text: localizer.tc(unit, value).trim(),
  };
};

export const createWaitingTime = (localizer) => {
  const fromDates = (firstDate, secondDate) => (
    waitingTimeFromDates(firstDate, secondDate, localizer)
  );

  return Object.freeze({
    units: WAITING_TIME_UNITS,
    fromDates,
    textFromDates: (firstDate, secondDate) => fromDates(firstDate, secondDate).text,
  });
};

export default {
  install(Vue, { i18n }) {
    Vue.prototype.$waitingTime = createWaitingTime(i18n);
  },
};
